import { SectionHeadingContainer } from '@/components/SectionHeadingContainer';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

/**
 * お悩みセクションと「選ばれる理由」のあいだの共感・橋渡しコピー
 */
export default function EmpathyBridgeSection() {
  const ref = useScrollAnimation();

  return (
    <section
      ref={ref}
      className="relative w-full overflow-hidden"
      style={{ backgroundColor: '#EDE9E0', paddingTop: '65px', paddingBottom: '88px' }}
      aria-label="あなただけではない想い"
    >
      <div
        className="pointer-events-none absolute left-0 top-0 bottom-0 w-px opacity-40"
        style={{
          background:
            'linear-gradient(180deg, transparent 0%, rgba(168,205,217,0.5) 20%, rgba(168,205,217,0.5) 80%, transparent 100%)',
        }}
        aria-hidden={true}
      />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-8 lg:px-16">
        {/* 英字ラベル：他セクション（OUR MESSAGE 等）と同じ余白・左揃え */}
        <div className="fade-in-up mb-6">
          <span
            className="section-label-en font-montserrat font-light uppercase"
            style={{ color: '#8FB4C8' }}
          >
            NOT ALONE
          </span>
        </div>

        <SectionHeadingContainer
          maxWidth="2xl"
          className="empathy-bridge-body text-center"
          style={{ color: '#2C2C2C', fontFamily: "'Noto Sans JP', sans-serif", fontWeight: 300 }}
        >
          <p className="empathy-bridge-copy fade-in-up delay-1 w-full">
            それは、あなただけではありません。
          </p>

          <p className="empathy-bridge-copy fade-in-up delay-2 w-full">
            多くの人が同じように感じながらも、
            <br />
            何も変えられずに時間だけが過ぎていきます。
          </p>

          <p
            className="empathy-bridge-copy fade-in-up delay-3 w-full"
            style={{ color: '#3D3D3D' }}
          >
            でも、環境が変われば、
            <br />
            考え方も、行動も、結果も変わる。
          </p>

          <p className="empathy-bridge-copy empathy-bridge-copy--roomy fade-in-up delay-4 w-full">
            ここには、
            <br />
            本気で変わりたい人が、
            <br />
            実際に変わっていける環境があります。
          </p>

          <p
            className="section-heading-sub fade-in-up delay-5 w-full"
            style={{
              color: '#1A1A1A',
            }}
          >
            では、なぜ変われるのか。
          </p>
        </SectionHeadingContainer>
      </div>
    </section>
  );
}
